import { z } from "zod";

const gpsPointSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});

/** Partner app → attendance: clock in, GPS-verified server-side (migration
 * 0026). Riders are checked against their hub; therapists against their own
 * registered home pin — the role on the verified JWT decides which, the
 * client never claims it. */
export const clockInSchema = gpsPointSchema;
export type ClockInInput = z.infer<typeof clockInSchema>;

/** Partner app → attendance: clock out. Blocked server-side while the staff
 * member has an active assignment/booking (money-math.md-adjacent —
 * dispatch/attendance consistency, not money itself). */
export const clockOutSchema = gpsPointSchema;
export type ClockOutInput = z.infer<typeof clockOutSchema>;

/** Partner app → attendance: presence heartbeat while clocked in — no
 * location data, roughly every 30s. Distinguishes "online" from "on duty"
 * for ASAP dispatch (migration 0028, per the client's ASAP flowchart). */
export const heartbeatSchema = z.object({}).strict();
export type HeartbeatInput = z.infer<typeof heartbeatSchema>;

export const attendanceRecordSchema = z.object({
  id: z.string().uuid(),
  staffId: z.string().uuid(),
  hubId: z.string().uuid(),
  clockIn: z.string().datetime({ offset: true }).nullable(),
  clockOut: z.string().datetime({ offset: true }).nullable(),
});
export type AttendanceRecord = z.infer<typeof attendanceRecordSchema>;
